import { createModalStore } from '@/shared/lib/modal';

export const useRetranslateProjectModalStore = createModalStore();
